module.exports = __webpack_public_path__ + "img/isola.49ee40f7.jpg";